import { Divider, Typography } from '@mui/material';

export const OrDivider = (): JSX.Element => (
  <Divider sx={{ color: (theme) => theme.palette.secondary.main }}>
    <Typography fontSize={16} sx={{ color: (theme) => theme.palette.tertiary.main }}>
      or
    </Typography>
  </Divider>
);
